// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';
export const API_TIMEOUT = 30000; // 30 seconds

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login/',
    LOGOUT: '/auth/logout/',
    // Backend lives at /api/auth/refresh/ (apps/api/auth/urls.py).
    // Keeping the wrong path here is what was kicking users out after
    // the access token expired — the 401 handler couldn't refresh.
    REFRESH: '/auth/refresh/',
    ME: '/auth/me/',
    CHANGE_PASSWORD: '/auth/change-password/',
  },
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info',
} as const;

// Token Configuration
export const TOKEN_CONFIG = {
  ACCESS_TOKEN_LIFETIME: 15 * 60 * 1000, // 15 minutes in milliseconds
  REFRESH_TOKEN_LIFETIME: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Invalid username or password. Please check your credentials and try again.',
  NETWORK_ERROR: 'Unable to connect to the server. Please check your internet connection and try again.',
  SERVER_ERROR: 'We encountered a server error. Please try again in a few moments.',
  TOKEN_EXPIRED: 'Your session has expired. Please log in again to continue.',
  UNAUTHORIZED: "You don't have permission to access this resource. Please contact your administrator.",
  LOGIN_REQUIRED: 'Please enter both username and password.',
  LOGOUT_ERROR: 'There was an issue logging out. Your session has been cleared.',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Welcome back! You have successfully logged in.',
  LOGOUT_SUCCESS: 'You have been successfully logged out.',
} as const;
